<template>
  <div class="wrap">
    <!-- 顶部标题 -->
    <div class="header_title">
      <div class="header_center">
        <div class="title">
          申报:
          <span>{{ $route.query.title }}</span>
        </div>
        <div class="back_page" @click="backpage">返回上一页</div>
      </div>
    </div>
    <!-- 表单盒子，左边的导航栏nav_left,右边的表单form_rightform_right -->
    <div class="form_box">
      <div class="form_right"  style="width:100%;margin-left:0px;" ref="exportPdf">
        <div class="form_1" >
          <!-- title提示标题文字,background提示盒子背景色,border提示盒子左边边框颜色 -->
          <Tips :title="tiptitle" :background="Contractorinfo.Tipsbackground" :border="Contractorinfo.Tipsborder"
            :states="Contractorinfo.Tipstates" style="width:100%"></Tips>
            <!--<el-form :rules="rules" ref="ruleForm">-->
                <el-tabs style="margin-top: 16px" v-model="activeName" @tab-click="handleClick">
                    <div class="flex">
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">姓名</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.name" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">性别</div>
                        <div class="form_content">
                          <el-radio-group size="small" class="inpyabeb" v-model="ruleForm.sex">
                            <el-radio label="1">男</el-radio>
                            <el-radio label="2">女</el-radio>
                          </el-radio-group>
                        </div>
                      </div>
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">民族</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.nation" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex">
                        <div class="my_form2">
                          <div class="form_title" style="height: 110px">头像</div>
                          <el-upload
                            style="height: 110px"
                            class="upload-demo"
                            :action="'/api/home/upload/file/user'"
                            limit="1"
                            accept=".jpg, .png"
                            :data="{ token: token }"
                            :on-exceed="handleExceed"
                            :on-remove="() => handleOnPicRemove('photo')"
                            :on-success="handleAddPhoto" 
                            :file-list="photo"
                            list-type="picture"
                          >
                            <el-button
                              size="small"
                              icon="el-icon-plus"
                              style="margin-right: 10px"
                              >选择文件</el-button
                            >
                            <div
                              slot="tip"
                              class="el-upload__tip"
                              v-if="photo == undefined || photo.length < 1"
                            >
                              只能上传jpg/png文件，且不超过500kb
                            </div>
                          </el-upload>
                        </div>
                      </div>
                      
                    
                    <div class="flex">
                        <div class="my_form">
                            <div class="form_title" style="height: 62px">出生年月</div>
                            <div class="form_content">
                              <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                                class="inpyabeb" v-model="ruleForm.birth"></el-date-picker>
                            </div>
                          </div>
                          <div class="my_form">
                            <div class="form_title" style="height: 62px">身份证号</div>
                            <div class="form_content">
                              <div :class=" idcard_err == 1. ? 'input ierr' : 'input'">
                                <input type="text" placeholder="请输入身份证号" v-model="ruleForm.idcard" />
                              </div>
                            </div>
                          </div>
                    </div>
                     <div class="flex">
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">手机号</div>
                        <div class="form_content">
                          <div :class=" mobile_err == 1. ? 'input ierr' : 'input'">
                            <input type="text" placeholder="请输入" v-model="ruleForm.mobile" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">电子邮箱</div>
                        <div class="form_content">
                          <div :class=" email_err == 1. ? 'input ierr' : 'input'">
                            <input type="text" placeholder="请输入" v-model="ruleForm.email" />
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="flex">
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">毕业院校</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.school" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">毕业时间</div>
                        <div class="form_content">
                          <div class="input">
                              <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                                class="inpyabeb" v-model="ruleForm.graduate_date"></el-date-picker>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="flex">
                        <div class="my_form2">
                        <div class="form_title" style="height: 62px">所学专业</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.major_studied" />
                          </div>
                        </div>
                      </div>
                      
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">现从事专业</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.major" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex">
                     <div class="my_form">
                        <div class="form_title" style="height: 62px">现从事专业工作年限</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="number" placeholder="请输入" v-model="ruleForm.working_years" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">职务</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.job" />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="flex">
                     <div class="my_form2">
                        <div class="form_title" style="height: 62px">获鲁班奖、国优奖项目</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.prize_projects" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">获奖时间</div>
                        <div class="form_content">
                          <div class="input">
                              <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                                class="inpyabeb" v-model="ruleForm.prize_date"></el-date-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="flex">
                     
                     <div class="my_form">
                        <div class="form_title" style="height: 62px">技术职称</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.technical_title" />
                          </div>
                        </div>
                      </div>
                      <div class="my_form">
                        <div class="form_title" style="height: 62px">技术职称时间</div>
                        <div class="form_content">
                          <div class="input">
                            <el-date-picker type="date" value-format="yyyy-MM-dd" format="yyyy-MM-dd" placeholder="选择日期"
                                class="inpyabeb" v-model="ruleForm.tech_date"></el-date-picker>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <div class="flex">
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">工作单位</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.unit" readonly="true"/>
                          </div>
                        </div>
                      </div>
                      <div class="my_form2">
                        <div class="form_title" style="height: 62px">单位地址</div>
                        <div class="form_content">
                          <div class="input">
                            <input type="text" placeholder="请输入" v-model="ruleForm.unit_address" />
                          </div>
                        </div>
                      </div>
                    </div>
                   <div class="my_form">
                    <div class="form_title" style="height: 62px">工程类别</div>
                    <div class="form_long form_long-1">
                      <el-radio-group v-model="ruleForm.major_type" size="small" class="inpyabeb"
                        @change="changeType(ruleForm.major_type)">
                        <el-radio v-for="(item, index) in type_major_arr" :label="item">{{ item }}</el-radio>
                      </el-radio-group>
                    </div>
                  </div>
                  <div class="my_form2">
                    <div class="form_title" style="height: 62px">专业</div>
                    <div class="form_long form_long-1">
                         <el-checkbox-group v-model="ruleForm.application_major" class="inpyabeb"  @change="changeMajor">
                             <el-checkbox v-for="(item, index) in major_arr" :label="item">{{ item }}</el-checkbox>
                             <div class="input" v-if="major_show_other == 1" style="margin-left:10px;">
                                <input type="text" placeholder="请输入" v-model="ruleForm.other_major" />
                              </div> 
                          </el-checkbox-group>
                         
                    </div>
                  </div>
                 <div class="my_form">
                    <div class="form_title" style="height: 62px">申请工作范围</div>
                    <div class="form_long form_long-1">
                         <el-checkbox-group v-model="ruleForm.work_jobs" class="inpyabeb" @change="changeWorkJob">
                             <el-checkbox v-for="(item, index) in work_jobs" :label="item.id" :value="item.id">{{ item.title }}</el-checkbox>
                              <div class="input" v-if="wj_show_other == 1" style="margin-left:10px;">
                                <input type="text" placeholder="请输入" v-model="ruleForm.work_job_remark" />
                              </div> 
                              
                          </el-checkbox-group>
                    </div>
                  </div>
                  <div class="my_form2">
                      <div class="form_title" style="min-height: 100px">
                        身份证正面
                      </div>
                      <div class="uploadinput">
                        <div class="uploadlist" style="margin-left:20px">
                            <el-upload
                            style="height: 110px"
                            class="upload-demo"
                            :action="'/api/home/upload/file/user'"
                            limit="1"
                            accept=".jpg, .png"
                            :data="{ token: token }"
                            :on-exceed="handleExceed"
                            :on-remove="() => handleOnPicRemove('idcard_front_pic')"
                            :on-success="handleAddIdcardFrontPic" 
                            :file-list="idcard_front_pic"
                            list-type="picture"
                          >
                            <el-button
                              size="small"
                              icon="el-icon-plus"
                              style="margin-right: 10px"
                              >选择文件</el-button
                            >
                            <div
                              slot="tip"
                              class="el-upload__tip"
                              v-if="idcard_front_pic == undefined ||  idcard_front_pic.length < 1"
                            >
                              只能上传jpg/png文件，且不超过500kb
                            </div>
                          </el-upload>
                          
                        </div>
                      </div>
                    </div>
                    
                    <div class="my_form">
                      <div class="form_title" style="min-height: 100px">
                        身份证反面
                      </div>
                      <div class="uploadinput">
                        <div class="uploadlist" style="margin-left:20px">
                             <el-upload
                            style="height: 110px"
                            class="upload-demo"
                            :action="'/api/home/upload/file/user'"
                            limit="1"
                            accept=".jpg, .png"
                            :data="{ token: token }"
                            :on-exceed="handleExceed"
                            :on-remove="() => handleOnPicRemove('idcard_reverse_pic')"
                            :on-success="handleAddIdcardReversePic" 
                            list-type="picture"
                            :file-list="idcard_reverse_pic"
                          >
                            <el-button
                              size="small"
                              icon="el-icon-plus"
                              style="margin-right: 10px"
                              >选择文件</el-button
                            >
                            <div
                              slot="tip"
                              class="el-upload__tip"
                              v-if="idcard_reverse_pic == undefined ||   idcard_reverse_pic.length < 1"
                            >
                              只能上传jpg/png文件，且不超过500kb
                            </div>
                          </el-upload>
                        </div>
                      </div>
                    </div>
                <div class="my_form2">
                  <div class="form_title" style="min-height: 100px">
                    申请表
                  </div>
                  <div class="uploadinput">
                    <div class="uploadlist" style="margin-left:20px">
                      <el-upload style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        " :action="'/api/home/upload/file/eproject'"
                        accept=".pdf" :limit="4"
                       :file-list="ruleForm.file_urls"
                       :on-remove="() => handleOnRemove('file_urls')"
                       :on-success="(res) => uploadSuccess(res, 'file_urls')" :before-upload="beforePdfUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-left: 10px" class="el-upload__tip">
                          只能上传pdf文件，且不超过100MB
                          <div><a href="/贵州省建筑业协会专家库专家申请表.doc" target="_blank">请下载贵州省建筑业协会专家库专家申请表模版，填写信息盖章后上传</a></div>
                          
                        </div>
                          
                      </el-upload>
                    </div>
                  </div>
                </div>
 
                <div class="my_form">
                  <div class="form_title" style="min-height: 100px">
                    毕业证书及学位证书
                  </div>
                  <div class="uploadinput">
                    <div class="uploadlist" style="margin-left:20px">
                      <el-upload style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        " :action="'/api/home/upload/file/eproject'"
                        accept=".pdf" :limit="4"
                       :file-list="ruleForm.cert_graduate"
                       :on-remove="() => handleOnRemove('cert_graduate')"
                       :on-success="(res) => uploadSuccess(res, 'cert_graduate')" :before-upload="beforePdfUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-left: 10px" class="el-upload__tip">
                          只能上传pdf文件，且不超过100MB
                        </div>
                          
                      </el-upload>
                    </div>
                  </div>
                </div>
                
                <div class="my_form2">
                  <div class="form_title" style="min-height: 100px">
                    职称资格证书
                  </div>
                  <div class="uploadinput">
                    <div class="uploadlist" style="margin-left:20px">
                      <el-upload style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        " :action="'/api/home/upload/file/eproject'"
                        accept=".pdf" :limit="4"
                       :file-list="ruleForm.cert_professional"
                       :on-remove="() => handleOnRemove('cert_professional')"
                       :on-success="(res) => uploadSuccess(res, 'cert_professional')" :before-upload="beforePdfUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-left: 10px" class="el-upload__tip">
                          只能上传pdf文件，且不超过100MB
                        </div>
                          
                      </el-upload>
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="min-height: 100px">
                    单位聘用证书
                  </div>
                  <div class="uploadinput">
                    <div class="uploadlist" style="margin-left:20px">
                      <el-upload style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        " :action="'/api/home/upload/file/eproject'"
                        accept=".pdf" :limit="4"
                       :file-list="ruleForm.cert_employ"
                       :on-remove="() => handleOnRemove('cert_employ')"
                       :on-success="(res) => uploadSuccess(res, 'cert_employ')" :before-upload="beforePdfUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-left: 10px" class="el-upload__tip">
                          只能上传pdf文件，且不超过100MB
                        </div>
                          
                      </el-upload>
                    </div>
                  </div>
                </div>
                <div class="my_form2">
                  <div class="form_title" style="min-height: 100px">
                    执业资格证书
                  </div>
                  <div class="uploadinput">
                    <div class="uploadlist" style="margin-left:20px">
                      <el-upload style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        " :action="'/api/home/upload/file/eproject'"
                        accept=".pdf" :limit="4"
                       :file-list="ruleForm.cert_practicing"
                       :on-remove="() => handleOnRemove('cert_practicing')"
                       :on-success="(res) => uploadSuccess(res, 'cert_practicing')" :before-upload="beforePdfUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-left: 10px" class="el-upload__tip">
                          只能上传pdf文件，且不超过100MB
                        </div>
                          
                      </el-upload>
                    </div>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="min-height: 100px">
                    业绩佐证材料
                  </div>
                  <div class="uploadinput">
                    <div class="uploadlist" style="margin-left:20px">
                      <el-upload style="
                          display: flex;
                          align-items: center;
                          margin-left: 10px;
                        " :action="'/api/home/upload/file/eproject'"
                        accept=".pdf" :limit="4"
                       :file-list="ruleForm.cert_achievement"
                       :on-remove="() => handleOnRemove('cert_achievement')"
                       :on-success="(res) => uploadSuccess(res, 'cert_achievement')" :before-upload="beforePdfUpload">
                        <el-button size="small" type="primary">点击上传</el-button>
                        <div slot="tip" style="margin-left: 10px" class="el-upload__tip">
                          只能上传pdf文件，且不超过100MB
                        </div>
                          
                      </el-upload>
                    </div>
                  </div>
                </div>
                
                <div class="my_form2">
                  <div class="form_title" style="height: 188px; text-align: center">
                    工作经历(1000字以内)
                  </div>
                  <div class="form_textarea">
                    <textarea name id cols="30" rows="15"  maxlength="1000" placeholder="包括时间、单位、工作内容及所从事的专业"
                      v-model="ruleForm.work_experience" @change="changeText('work_experience',1000)"></textarea>
                  </div>
                </div>
                <div class="my_form">
                  <div class="form_title" style="height: 188px; text-align: center">
                    主要业绩 和论著 (1000字以内)
                  </div>
                  <div class="form_textarea">
                    <textarea name id cols="30" rows="15" maxlength="1000" placeholder="获奖项目名称、等级或论著题目、鉴定单位或出版单位"
                      v-model="ruleForm.performance" @change="changeText('performance',1000)"></textarea>
                  </div>
                </div>
                </el-tabs>
                
                <div class="btns flex">
                    <el-button class="online" icon="el-icon-view" :plain="true" @click="printPdf" style="width: 236px; height: 50px; margin-top: 20px; margin-right: 10px; font-size: 18px;">在线预览</el-button>
                    <div class="sumbit" :class="issumbitshow ? 'blue' : ''" @click="asumbit">
                        <img src="../assets/19178@2x.png" alt />
                        <p>提交平台审核</p>
                      </div>
                </div>
                 
                  
              <!--</el-form>-->
          
         
          
        </div>

      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { EprojectDeclare, EprojectDeclareDetails, EprojectDeclareModify,AwardList ,SaveEDraft,EDraftrecord,GetMember} from "../utils/api";
import Footer from "../components/Footer";
import Tips from "../components/Modal/tips"; //提示组件
import GreenProjcet from '../components/fromProjcet/greenProject.vue'
export default {
  components: {
    Tips,
    Footer,
    GreenProjcet
  },
  data() {
    return {
      btnSaveStatus: false,
      currentSubmit: false,
      tipserror: 0,
      form: {
        type: [],
      },
      islist: "0",
      work_jobs:[],
      token: "",
      photo:[],
      idcard_front_pic:[],
      idcard_reverse_pic:[],
      tiptitle:'简况',
      ruleForm: {
        name: "",
        birth: "",
        school: "",
        sex:"1",
        major_studied: "",
        major: "",
        working_years: "",
        unit: "",
        job: "",
        technical_title: "",
        idcard: "", //法定身份证号
        // Social_name:'',//社会组织名称
        mobile: "", //法人电话
        email: "", //本组织现任职务
        unit_address: "", //是否秘书长
        major_type: "", //是否法定代表人
        application_major: [], //政治面貌
        work_jobs: [], //文化程度
        other_major:"",
        file_urls:[],
        cert_graduate:[],
        cert_professional:[],
        cert_practicing:[],
        cert_achievement:[],
        cert_employ:[],
        idcard_front_pic:"",
        idcard_reverse_pic:"",
        photo:"",
        nation:"",
        graduate_date:"",
        tech_date:"",
        prize_projects:"",
        prize_date:"",
        work_experience:"",
        performance:"",
        work_job_remark:""
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          }
        ],
        birth: [
          {
            required: true,
            message: "请输入出生年月",
            trigger: "blur",
          },
        ],
        school: [
          {
            required: true,
            message: "请输入毕业院校",
            trigger: "blur",
          },
        ],
        major_studied: [
          {
            required: true,
            message: "请输入所学专业",
            trigger: "blur",
          },
        ],
        major: [
          {
            required: true,
            message: "请输入现从事专业",
            trigger: "blur",
          },
        ],
        working_years: [
          {
            required: true,
            message: "请输入现从事专业工作年限",
            trigger: "blur",
          },
        ],
        unit: [
          {
            required: true,
            message: "请输入工作单位",
            trigger: "blur",
          },
        ],
        job: [
          {
            required: true,
            message: "请输入职务",
            trigger: "blur",
          },
        ],
        technical_title: [
          {
            required: true,
            message: "请输入技术职称",
            trigger: "blur",
          },
        ],
        idcard: [
          {
            required: true,
            message: "请输入身份证号",
            trigger: "blur",
          },
        ],
        mobile: [
          {
            required: true,
            message: "请输入手机号",
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            message: "请输入电子邮箱",
            trigger: "blur",
          },
        ],
        unit_address: [
          {
            required: true,
            message: "请输入单位地址",
            trigger: "blur",
          },
        ],
        major_type: [
          {
            required: true,
            message: "请选择工程类别",
            trigger: "blur",
          },
        ],
        application_major: [
          {
            required: true,
            message: "请选择专业",
            trigger: "blur",
          },
        ],
        work_jobs: [
          {
            required: true,
            message: "请选择申请工作范围",
            trigger: "blur",
          },
        ]
      },
      rId: 0,//记录id
      
      type_major_arr: [
        "建筑工程及市政园林工程",
        "交通工程",
        "水利工程",
        "电力工程",
        "其它工程",
      ],
      major_arr:[],
      type_build_arr: [
        "土建专业",
        "安装专业",
        "其他"
      ],
      type_traffic_arr: [
        "道路与桥梁工程",
        "轨道交通工程",
        "铁路工程",
        "其他"
      ],
      type_water_arr: [
        "水利枢纽工程",
        "河道整治工程",
        "灌区与排涝工程",
        "水土保持工程",
        "水文水资源工程",
        "其他水利相关工程"
      ],
      type_electric_arr: [
        "发电工程",
        "输变电工程",
        "供配电工程",
        "电力系统自动化",
        "其他电力相关工程"
      ],
      type_other_arr: [
        "应急抢险工程",
        "其他"
      ],
      activeName: '',
      Contractorinfo: {},
      issumbitshow:false,
      currentSubmit:false,
      email_err:0,
      mobile_err:0,
      idcard_err:0,
      major_show_other:0,
      wj_show_other:0,
      work_job_other:0,
      vtid:0
    };
  },
  async created() {
    var _this = this;
    let res;
    let member = await GetMember();
    this.ruleForm.unit = member.enterprise_name;
    this.token = "Bearer " + localStorage.getItem("TOKEN");
    //获取申请分类
    const pdata = {
        page_size: 0,
        page: 1,
        eproject:1
      };
      let ares = await AwardList(pdata);
      this.work_jobs = ares || [];
      console.log('this.work_jobs',this.work_jobs);
      for(let j = 0;j < this.work_jobs.length; j++){
          if(this.work_jobs[j]['title'].indexOf('其他') !== -1){
              this.work_job_other = this.work_jobs[j]['id'];
              break;
          }
      }
    _this.vtid = this.$route.query.vtid
    if (this.$route.query.r) {
      this.rId = this.$route.query.r;
      //判断是否存在记录id，如果是则表示是申请记录审核失败的
      if (this.rId) {
        res = await EprojectDeclareDetails(this.rId);
         console.log('this.$route.query res',res)
        if(res) {
            _this.ruleForm.name = res.name
            _this.ruleForm.nation = res.nation;
            _this.ruleForm.birth = res.birth;
            _this.ruleForm.school = res.school;
            _this.ruleForm.sex = res.sex;
            _this.ruleForm.major_studied = res.major_studied;
            _this.ruleForm.major = res.major;
            _this.ruleForm.working_years = res.working_years;
            _this.ruleForm.unit = res.unit;
            _this.ruleForm.job = res.job;
            _this.ruleForm.technical_title = res.technical_title;
            _this.ruleForm.idcard = res.idcard;
            _this.ruleForm.mobile = res.mobile;
            _this.ruleForm.email = res.email;
            _this.ruleForm.unit_address = res.unit_address;
            _this.ruleForm.major_type = res.major_type;
            _this.ruleForm.application_major = res.application_major;
            _this.ruleForm.work_jobs = [];
            _this.wj_show_other = 0;
            for(let j =0;j < res.work_jobs.length; j++){
                _this.ruleForm.work_jobs.push( parseInt(res.work_jobs[j]) )
                if( res.work_jobs[j] == _this.work_job_other ){
                    _this.wj_show_other = 1;
                }
            }
            _this.ruleForm.work_job_remark = res.work_job_remark;
            _this.ruleForm.performance = res.performance;
            _this.ruleForm.work_experience = res.work_experience;
            _this.ruleForm.prize_date = res.prize_date;
            _this.ruleForm.prize_projects = res.prize_projects;
            _this.ruleForm.tech_date = res.tech_date;
            _this.ruleForm.graduate_date = res.graduate_date;
            _this.ruleForm.work_job_titles = res.work_job_titles;
            _this.ruleForm.photo = res.photo;
            _this.ruleForm.idcard_reverse_pic = res.idcard_reverse_pic;
            _this.ruleForm.idcard_front_pic = res.idcard_front_pic;
            if(_this.ruleForm.photo){
                _this.photo = [ {'url':res.photo,'name':'','status':'success','uid':1}];
            }
            if(_this.ruleForm.idcard_front_pic){
                _this.idcard_front_pic = [ {'url':res.idcard_front_pic,'name':'','status':'success','uid':1}];
            }
            if(_this.ruleForm.idcard_reverse_pic){
                _this.idcard_reverse_pic = [ {'url':res.idcard_reverse_pic,'name':'','status':'success','uid':1}];
            }
            
            
            _this.project_batch_id = res.project_batch_id;
            if (_this.ruleForm.major_type == "建筑工程及市政园林工程") {
                _this.major_arr = _this.type_build_arr;
              }
              if (_this.ruleForm.major_type == "交通工程") {
                _this.major_arr = _this.type_traffic_arr;
              }
              if (_this.ruleForm.major_type == "水利工程") {
               _this.major_arr = _this.type_water_arr;
              }
              if (_this.ruleForm.major_type == "电力工程") {
                  _this.major_arr = _this.type_electric_arr;
              }
              if (_this.ruleForm.major_type == "其它工程") {
                _this.major_arr = _this.type_other_arr;
              }
              
              for(let i = 0; i < res.application_major.length; i++){
                                                       console.log('_this.ruleForm.application_major',_this.major_arr.indexOf(_this.ruleForm.application_major[i]))

                  if(_this.major_arr.indexOf(res.application_major[i]) === -1){
                      if (_this.ruleForm.major_type == "水利工程") {
                        _this.ruleForm.application_major.push('其他水利相关工程');
                      } else if (_this.ruleForm.major_type == "电力工程") {
                          _this.ruleForm.application_major.push('其他电力相关工程');
                      } else {
                          _this.ruleForm.application_major.push('其他');
                      }
                      console.log('_this.ruleForm.application_major 3', _this.ruleForm.application_major[i])
                      _this.ruleForm.other_major = res.application_major[i];
                      _this.ruleForm.application_major.splice(_this.ruleForm.application_major.indexOf(res.application_major[i]), 1);
                      _this.major_show_other = 1;
                      break;
                  }
              }
            console.log('_this.ruleForm.application_major',_this.ruleForm)
            //_this.ruleForm.other_major = res.other_major;
            _this.ruleForm.file_urls = res.file_urls;
            _this.ruleForm.cert_graduate = res.cert_graduate;
            _this.ruleForm.cert_professional = res.cert_professional;
            _this.ruleForm.cert_practicing = res.cert_practicing;
            _this.ruleForm.cert_employ = res.cert_employ;
            _this.ruleForm.cert_achievement = res.cert_achievement;
            console.log('ruleForm',_this.ruleForm);
        }
      }
      
    }
    
    if(!res && _this.vtid && _this.vtid != undefined){
          EDraftrecord(_this.$route.query.id, _this.$route.query.project_batch_id,_this.vtid).then(res => {
            console.log('----------------------1111res1111----------------------');
            console.log(res);
            if (JSON.stringify(res) != "{}") {
                _this.ruleForm.name = res.name
                _this.ruleForm.birth = res.birth;
                _this.ruleForm.nation = res.nation;
                _this.ruleForm.school = res.school;
                _this.ruleForm.major_studied = res.major_studied;
                _this.ruleForm.major = res.major;
                _this.ruleForm.working_years = res.working_years;
                _this.ruleForm.unit = res.unit;
                _this.ruleForm.job = res.job;
                _this.ruleForm.technical_title = res.technical_title;
                _this.ruleForm.idcard = res.idcard;
                _this.ruleForm.mobile = res.mobile;
                _this.ruleForm.email = res.email;
                _this.ruleForm.unit_address = res.unit_address;
                _this.ruleForm.major_type = res.major_type;
                _this.ruleForm.application_major = res.application_major;
                for(let j =0;j < res.work_jobs.length; j++){
                    _this.ruleForm.work_jobs.push( parseInt(res.work_jobs[j]) )
                    if( res.work_jobs[j] == _this.work_job_other ){
                        _this.wj_show_other = 1;
                    }
                }
                _this.ruleForm.work_job_remark = res.work_job_remark;
                _this.ruleForm.work_experience = res.work_experience;
                _this.ruleForm.performance = res.performance;
                _this.ruleForm.sex = res.sex;
                
                _this.ruleForm.prize_date = res.prize_date;
                _this.ruleForm.prize_projects = res.prize_projects;
                _this.ruleForm.tech_date = res.tech_date;
                _this.ruleForm.graduate_date = res.graduate_date;
                _this.ruleForm.photo = res.photo;
                _this.ruleForm.work_job_titles = res.work_job_titles;
                _this.ruleForm.performance = res.performance;
                _this.ruleForm.work_experience = res.work_experience;
                _this.ruleForm.project_id = res.project_id;
                _this.ruleForm.project_batch_id = res.project_batch_id;
                _this.ruleForm.idcard_front_pic = res.idcard_front_pic;
                _this.ruleForm.idcard_reverse_pic = res.idcard_reverse_pic;
                if(res.photo){
                    _this.photo = [ {'url':res.photo,'name':'','status':'success','uid':1}];
                }
                if(_this.ruleForm.idcard_front_pic){
                    _this.idcard_front_pic = [ {'url':res.idcard_front_pic,'name':'','status':'success','uid':1}];
                }
                if(_this.ruleForm.idcard_reverse_pic){
                    _this.idcard_reverse_pic = [ {'url':res.idcard_reverse_pic,'name':'','status':'success','uid':1}];
                }
                
                
                if (_this.ruleForm.major_type == "建筑工程及市政园林工程") {
                    _this.major_arr = _this.type_build_arr;
                  }
                  if (_this.ruleForm.major_type == "交通工程") {
                    _this.major_arr = _this.type_traffic_arr;
                  }
                  if (_this.ruleForm.major_type == "水利工程") {
                      _this.major_arr = _this.type_water_arr;
                  }
                  if (_this.ruleForm.major_type == "电力工程") {
                    _this.major_arr = _this.type_electric_arr;
                  }
                  if (_this.ruleForm.major_type == "其它工程") {
                    _this.major_arr = _this.type_other_arr;
                  }
                  
                  for(let i = 0; i < _this.ruleForm.application_major.length; i++){
                                     console.log('_this.ruleForm.application_major 1',_this.major_arr.indexOf(_this.ruleForm.application_major[i]))

                      if(_this.major_arr.indexOf(_this.ruleForm.application_major[i]) === -1){
                          if (_this.ruleForm.major_type == "水利工程") {
                            _this.ruleForm.application_major.push('其他水利相关工程');
                          } else if (_this.ruleForm.major_type == "电力工程") {
                              _this.ruleForm.application_major.push('其他电力相关工程');
                          } else {
                              console.log('_this.ruleForm.application_major 3')
                              _this.ruleForm.application_major.push('其他');
                          }
                          console.log('_this.ruleForm.application_major 2', _this.ruleForm.application_major[i])
                          //_this.ruleForm.application_major.push('其他');
                          _this.ruleForm.other_major = _this.ruleForm.application_major[i];
                          _this.ruleForm.application_major.splice(_this.ruleForm.application_major.indexOf(_this.ruleForm.application_major[i]), 1);
                          _this.major_show_other = 1;
                          break;
                      }
                  }
                console.log('_this.ruleForm.application_major',_this.ruleForm)
                //_this.ruleForm.other_major = res.other_major;
                _this.ruleForm.file_urls = res.file_urls;
                _this.ruleForm.cert_graduate = res.cert_graduate;
                _this.ruleForm.cert_professional = res.cert_professional;
                _this.ruleForm.cert_practicing = res.cert_practicing;
                _this.ruleForm.cert_achievement = res.cert_achievement;
                _this.ruleForm.cert_employ = res.cert_employ;
                console.log('ruleForm',_this.ruleForm);
            } 
          })
      }
      
   
  },
  computed: {
    issumbitshow: function () {
      let issumbit = true;
      
      return issumbit;
    },
  },
  watch: {
    
    ruleForm: {
      handler: function (newval, oldval) {
        console.log('handler',newval);
        let count = 0;
        let isshenbao = 0;
        let istrue = true;
        
        console.log('this.ruleForm',this.ruleForm)
        this.tiptitle = '';
        for (const key in this.ruleForm) {
            if(key == 'email'){
              const reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
              if(!reg.test(this.ruleForm[key])){
                  this.tiptitle = '请输入正确邮箱';
                  istrue = false;
                  this.email_err = 1;
              } else {
                  this.email_err = 0;
              }
              
          } else if(key == 'mobile'){
              const phonePattern = /^1[3-9]\d{9}$/;
              if(!phonePattern.test(this.ruleForm[key])){
                  this.tiptitle = '请输入正确手机号';
                  istrue = false;
                  this.mobile_err = 1;
              } else {
                  this.mobile_err = 0;
              }
          } else if(key == 'idcard' && this.ruleForm['idcard']){
              const reg =  /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(10|11|12))((0[1-9])|([1-2][0-9])|30|31)\d{3}(\d|X)$/i;
              if(!reg.test(this.ruleForm[key])){
                  this.tiptitle = '请输入正确身份证号';
                  istrue = false;
                  this.idcard_err = 1;
              } else {
                  this.idcard_err = 0;
              }
              
          }
          
          if (key != 'other_major' && key != 'file_urls' && (this.ruleForm[key] === "" || this.ruleForm[key] === null ||  this.ruleForm[key] === undefined ) && key != 'work_job_titles' && key != 'work_job_remark'  && key != 'log_id' ) {
            istrue = false;
          }
          
        }
        console.log('istrue',istrue)
        if (istrue) {
          this.tiptitle = '';
          this.Contractorinfo.Tipsbackground = "#EDF8F5";
          this.Contractorinfo.Tipstates = true;
          this.Contractorinfo.Tipsborder = "#1ABF98";
          this.issumbitshow = true;
          console.log(11);
        } else {
          this.Contractorinfo.Tipstates = false;
          this.Contractorinfo.Tipsbackground = "#FEF8EF";
          this.Contractorinfo.Tipsborder = "#FFB700";
          this.issumbitshow = false;
        }
      },
      deep: true,
    },
    
  },
  methods: { 
      //保存草稿
    SaveDraftleft() {
      this.btnSaveStatus = true;
      let data;
      let lessonObj;
      let list = {};
      console.log(this.$route.query.title);
      return SaveEDraft(this.$route.query.id, this.ruleForm,this.$route.query.project_batch_id).then(res => {
            this.$message({
              message: "保存草稿成功",
              type: "success",
            });
            this.btnSaveStatus = false;
          }).catch(err => {
            this.btnSaveStatus = false;
            this.$alert(err, {
              confirmButtonText: '我知道了',
            });
            //this.$message.error(err)
          });
    },
    
    handleAddPhoto(response, file, fileList) {
     console.log('response handleAddPhoto',response)
     console.log('file',file)
     console.log('fileList handleAddPhoto',fileList)
      this.photo = fileList;
      this.ruleForm.photo = response.data.host + response.data.url;
    },
     handleAddIdcardFrontPic(response, file, fileList) {
     console.log('response handleAddIdcardFrontPic',response)
     console.log('file',file)
     console.log('fileList',fileList)
      this.idcard_front_pic = fileList;
      this.ruleForm.idcard_front_pic = response.data.host + response.data.url;
    },
     handleAddIdcardReversePic(response, file, fileList) {
     console.log('response handleAddIdcardReversePic',response)
     console.log('file',file)
     console.log('fileList',fileList)
      this.idcard_reverse_pic = fileList;
      this.ruleForm.idcard_reverse_pic = response.data.host + response.data.url;
    },
    handleOnPicRemove(key,file){
         if(key == 'photo'){
            this.photo = [];
            this.ruleForm.photo = "";
        }
        if(key == 'idcard_front_pic'){
            this.idcard_front_pic = [];
            this.ruleForm.idcard_front_pic = "";
        }
        if(key == 'idcard_reverse_pic'){
            this.idcard_reverse_pic = [];
            this.ruleForm.idcard_reverse_pic = "";
        }
    },
    // handleAddPhoto(response, key, fileList) {
    //     console.log('handleAddPhoto',response)
    //     console.log('handleAddPhoto key',key)
    //     console.log('handleAddPhoto fileList',fileList)
    //     const file = {
    //         url: response.data.host + response.data.url,
    //         name: response.data.originalName
    //     }
    //     if(key == 'photo'){
    //         this.photo = fileList;
    //         this.ruleForm.photo = response.data.host + response.data.url;
    //     }
    //     if(key == 'idcard_front_pic'){
    //         this.idcard_front_pic = fileList;
    //         this.ruleForm.idcard_front_pic = response.data.host + response.data.url;
    //     }
    //     if(key == 'idcard_reverse_pic'){
    //         this.idcard_reverse_pic = fileList;
    //         this.ruleForm.idcard_reverse_pic = response.data.host + response.data.url;
    //     }
        
    // },
   
    handleRemove(file) {
      this.photo = [];
      this.ruleForm.photo = "";
    },
     handleExceed() {
      this.$message.warning(`请最多上传 1 个文件。`);
    },
    handleOnRemove(key, file) {
        this.ruleForm[key] = []
        this.judgeUploadFull()
    },
    uploadSuccess(response, key, fileList) {
        const file = {
            url: response.data.host + response.data.url,
            name: response.data.originalName
        }
        this.ruleForm[key] = [file]
    },
    beforePdfUpload(file) {
      let filesize = (Math.ceil(file.size / 1024) / 1024).toFixed(2);
      console.log(file);
      if (filesize > 100) {

        this.$message.error("上传文件不能大于100MB");
        return false;
      }
      //检查文件类型
      const fileName = file.name;
      const fileType = fileName.substring(fileName.lastIndexOf('.'));
      console.log('fileType',fileType)
      if(fileType != '.pdf'){
          this.$message.error("只能上传pdf文件");
          return false;
      }

    },
    
    //非空验证 参数：根据对象名，对象内有多少条属性，属性名
    noempty(obj, num, name) {
      var empty = true;
      console.log(num)
      console.log(obj)
      for (let i = 1; i <= num; i++) {
        if (obj[name + i] == "" || obj[name + i] == undefined) {
          console.log(obj[name + i])
          console.log(name )
          console.log(i)
          empty = false;
        }
      }
      console.log(empty)
      return empty;
    },
   
    async asumbit() {
      console.log('asumbit')
      if (this.currentSubmit) {
        return false;
      }
      if(!this.issumbitshow){
          return false;
      }
      this.currentSubmit = true;
      EprojectDeclare(this.$route.query.id, this.ruleForm,this.rId,this.$route.query.project_batch_id).then((res) => {
              this.$router.push("/member/eprojectdeclear");
              this.$message({
                message: "提交审核成功",
                type: "success",
              });
              this.currentSubmit = false;
            }).catch(err => {
              this.currentSubmit = false;
              this.$alert(err, {
                confirmButtonText: '我知道了',
              });
              //this.$message.error(err)
            })
        return true;
    },
    changeType(e) {
      console.log(e);
      if (e == "建筑工程及市政园林工程") {
        this.major_arr = this.type_build_arr;
      }
      if (e == "交通工程") {
        this.major_arr = this.type_traffic_arr;
      }
      if (e == "水利工程") {
       this.major_arr = this.type_water_arr;
      }
      if (e == "电力工程") {
        this.major_arr = this.type_electric_arr;
      }
      if (e == "其它工程") {
        this.major_arr = this.type_other_arr;
      }
      
    },
    changeWorkJob(e){
        let work_job_other = 0;
        for(let i = 0; i < e.length; i++){
            if(e[i] == this.work_job_other){
                this.wj_show_other = 1;
                work_job_other = 1;
                break;
            }
        }
        if(work_job_other == 0){
            this.ruleForm.work_job_remark = '';
        }
        
       
    },
    changeMajorType(e) {
      console.log(e);
      let lefttitlelist = JSON.parse(JSON.stringify(this.lefttitlelist))
      lefttitlelist[1].isok = true;
      this.lefttitlelist = lefttitlelist;
      // this.parameters4.info.type_of_major = e;
    },
    changeMajor(e){
        console.log('e.indexOf其他',e.indexOf('其他') )
        console.log('e.indexOf其他水利相关工程',e.indexOf('其他水利相关工程') )
        console.log('e.indexOf其他电力相关工程',e.indexOf('其他电力相关工程') )
        if(e.indexOf('其他') === -1 && e.indexOf('其他水利相关工程') === -1 && e.indexOf('其他电力相关工程') === -1){
            this.major_show_other = 0;
            this.ruleForm.other_major = '';
        } else {
            this.major_show_other = 1;
        }
        
         console.log('changeMajor',e);
    },
    //在线预览
    async printPdf() {
      let data;
      let istrue = true;
      let count = 0;
       await SaveEDraft(this.$route.query.id, this.ruleForm,this.$route.query.project_batch_id).then(res =>{
           console.log('printPdf',res)
          if(this.ruleForm['work_job_titles'] == undefined){
              //循环获取
              let work_job_titles = [];
              for(let i = 0; i < this.work_jobs.length; i++){
                  if( this.ruleForm.work_jobs.includes(this.work_jobs[i].id ) ){
                      work_job_titles.push(this.work_jobs[i].title);
                  }
                  
              }
              this.ruleForm['work_job_titles'] = work_job_titles.join(',');
          }
          
        let currentDate = new Date();
        let year = currentDate.getFullYear(); // 获取当前年份
        let month = currentDate.getMonth() + 1; // 获取当前月份，注意月份从0开始，所以要加1
        let day = currentDate.getDate(); // 获取当前日期
          this.ruleForm.created_at = year+'-'+month+'-'+day;
          sessionStorage.setItem(
            "ruleForm",
            JSON.stringify(this.ruleForm)
          );
          if(this.rId){
              this.$router.push(`/word_eproject?projectid=${this.$route.query.id}&projectbatchid=${this.$route.query.project_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbitshow}&id=${this.rId}&vtid=${res.id}`);
          } else {
              this.$router.push(`/word_eproject?projectid=${this.$route.query.id}&projectbatchid=${this.$route.query.project_batch_id}&title=${this.$route.query.title}&issumbit=${this.issumbitshow}&vtid=${res.id}`);
          }
       }).catch(err => {
        this.$alert(err, {
          confirmButtonText: '我知道了',
        });
        //this.$message.error(err)
        return false;
      });
      
      
    },
    //返回上一页
    backpage() {
      this.$router.go(-1);
    },
    
    //锚点滚动
    scrollnum(id) {
      document
        .querySelector(id)
        .scrollIntoView({ behavior: "smooth", block: "start" });

    },
    changeText(type,maxLength){
        var obj = '';
        if(type == 'work_experience'){
            obj = this.ruleForm.work_experience;
        } else {
            obj = this.ruleForm.performance;
        }
        console.log('obj.length',obj.length)
        if (obj.length > maxLength) {
          obj = obj.substring(0, maxLength);
          console.log('obj',obj.length)
        }
    }
  },
};
</script>
<style>
  .tooltip-width {
    max-width: 400px;

  }
  .el-icon-info{
    margin-left: 460px;
  }
</style>
<style lang="less" scoped>
@import './myform.less';
</style>
<style>
.el-upload-list__item-name{
  width:250px
}
.el-upload-list {
  height: 50px;
  display: flex;
  align-items: center;
}

.el-upload-list__item {
  transition: none !important;
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}
</style>


<style lang="less">
.el-tabs__nav-scroll {
  display: flex;
  justify-content: center;

  .el-tabs__item,
  .is-active {
    color: #7c828a;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .el-tabs__item.is-active {
    color: #194abe;
    font-size: 16px;
    font-family: Source Han Sans CN;
    font-weight: bold;
  }

  .el-tabs__item:hover {
    color: #194abe;
  }

  .el-tabs__active-bar {
    background-color: #194abe;
  }
}

.el-form-item__error {
  margin-left: 140px;
}

.el-form-item__label {
  min-width: 300px;
}

.el-form-item__content {
  text-align: left;
}

.block-solid {
  margin-top: 70px;
}
</style>
<style scoped lang="less">
.flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bot-red-border {
  width: 100%;
  border-top: 2px solid #e51725;
  display: flex;
  justify-content: center;
  padding-top: 37px;
  margin-top: 40px;
  .btn-give_up {
    cursor: pointer;
    width: 189px;
    height: 50px;
    line-height: 50px;
    text-align: center;
    background: #ffffff;
    border: 1px solid #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #194abe;
  }
  .btn-modify {
    cursor: pointer;
    width: 189px;
    height: 50px;
    background: #194abe;
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    margin: 0 10px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 18px;
      height: 14px;
      margin-right: 10px;
    }
    p {
      font-size: 18px;
      font-family: Microsoft YaHei;
      font-weight: bold;
      line-height: 27px;
      color: #ffffff;
    }
  }
}
.demo-ruleForm {
  width: 100%;
  margin: 30px 0;
  text-align: center;
  .inpyabeb {
    width: 50%;
  }
}
.my_form,
.my_form2 {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  overflow: auto;
  align-items: stretch;
  .form_title {
    background: #eaf0f6;
    width: 129px;
    min-width: 129px;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    line-height: 20px;
    padding: 0 6px;
    box-sizing: border-box;
    color: #0c0d0f;
  }
  .uploadinput {
    display: flex;
    flex-direction: column;
    justify-content: center;
    .uploadlist {
      display: flex;
      align-items: center;
      margin: 10px 0;
    }
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      display: flex;
      align-items: center;
      margin-left: 20px;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_content,
  .form_long,
  .form_choice {
    width: 300px;
    padding: 0px 6px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    input {
      width: 257px;
      height: 36px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 0 15px;
      box-sizing: border-box;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
    .input {
      width: 257px;
      display: flex;
      position: relative;
      span {
        position: absolute;
        right: 10px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
  }
  .form_choice_long {
    display: flex;
    justify-content: start;
    align-items: center;
    width: 729px;
    padding-left: 20px;
    box-sizing: border-box;
    background: #f5f8fb;
  }
  .form_long {
    width: 729px;
    input {
      width: 688px;
    }
    div{
      display: flex;
      align-items: center;
      /deep/.el-upload-list{
        margin: 0 !important;
		flex-wrap: wrap;
		li{
			width: 200px;
			margin-left: 10px;
		}
      }
    }
  }
  .form_long-1{
    display: flex;
    align-items: left;
    justify-content: left!important;;
	padding-left: 30px!important;
  }
  .form_textarea {
    width: 729px;
    height: 188px;
    display: flex;
    background: #f5f8fb;
    flex-direction: column;
    justify-content: space-evenly;
    padding-left: 20px;
    textarea {
      width: 688px;
      height: 127px;
      background: #ffffff;
      border: 1px solid #bdc3cb;
      opacity: 1;
      border-radius: 4px;
      padding: 9px 15px;
      box-sizing: border-box;
      color: #000;
      &:focus {
        outline: none;
        border: 1px solid #194abe;
      }
    }
  }
  .uploadimg {
    width: 729px;
    padding: 20px;
    background: #f5f8fb;
    box-sizing: border-box;
  }
  .Downinpustyle {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    background: #f5f8fb;
    .nejje {
      color: #194abe !important;
    }
  }
  .upload-demo {
    width: 729px;
    padding-left: 20px;
    background: #f5f8fb;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    height: 100px;
    .el-upload__tip {
      margin-left: 10px;
    }
  }
}
.my_form {
}
.my_form2 {
  .form_title {
    background: #f5f8fb;
  }
  .form_content,
  .form_long,
  .form_textarea,
  .form_choice,
  .form_choice_long,
  .upload-demo,
  .Downinpustyle {
    background: #fbfdff;
  }
}
.from-div{
	padding-bottom: 12px;
}
.form-lable{
	width: 100%;
    display: flex;
	justify-content: left;
	align-items: center;
	margin-bottom: 8px;
	.left{
		font-size: 16px;
		font-weight: bolder;
	}
	.right{
		display: flex;
		flex-direction: row;
		justify-content: center;
		align-items: center;
		border:1px solid #F9656F;
		border-radius: 5px;
		padding: 2px 8px;
		margin-left: 15px;
		img{
			width: 15px;
			height: 15px;
		}
		.delete-txt{
			font-size: 14px;
			font-weight: bolder;
			color: #F9656F;
			margin-left: 5px;
		}
	}
}
.el-upload-list {
	flex-wrap: wrap;
	margin: 0;
	padding: 0;
	list-style: none;
}
.form_long,.form_content {
    width:100% !important;
}
.sumbit {
    background: #d4dbdd;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 700;
    line-height: 27px;
    color: #fff;
    cursor: pointer;
    width: 236px;
    height: 50px;
    /* background: #fff; */
    opacity: 1;
    border-radius: 4px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 20px;
}
.blue {
    background: #194abe!important
}
.my_form2 .form_long div, .my_form .form_long div {
    flex-wrap: wrap;
}
.ierr input {
    border: 1px solid red !important
}
</style>
